"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportGroupBy_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ReportGeneratorReportType_1 = require("./ReportGeneratorReportType");
var ReportGroupBy_Factory = /** @class */ (function () {
    function ReportGroupBy_Factory() {
    }
    ReportGroupBy_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Id: model.Id,
            Name: model.Name,
            ReportTypes: model.ReportTypes && model.ReportTypes.map(function (i) { return ReportGeneratorReportType_1.ReportGeneratorReportType_Factory.CreateIncoming(i); }),
        };
        return result;
    };
    ReportGroupBy_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Id: model.Id,
            Name: model.Name,
            ReportTypes: model.ReportTypes && model.ReportTypes.map(function (i) { return ReportGeneratorReportType_1.ReportGeneratorReportType_Factory.CreateOutgoing(i); }),
        };
        return result;
    };
    return ReportGroupBy_Factory;
}());
exports.ReportGroupBy_Factory = ReportGroupBy_Factory;
